import React, { Component } from 'react'
import { equals } from 'ramda'
import { Input, Div, P } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { LABELS } from 'components/ContactFilterBuilder/constants/SegmentLabels'

class SetSegmentName extends Component {
  componentDidMount() {
    this.timer = null
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this.timer = null
  }

  setSegmentType = (event) => {
    const { onChangeSegmentType } = this.props

    onChangeSegmentType(event.target.value)
  }

  setSegmentName = (event) => {
    clearTimeout(this.timer)

    const { onChangeSegmentName } = this.props

    this.timer = setTimeout(onChangeSegmentName(event.target.value), 500)
  }

  render() {
    const {currentSegment, onBackNavigation} = this.props

    return (
      <Div className="filter-builder--set-name-and-type">
        <Div className="filter-builder--back-button" onClick={onBackNavigation}>
          <Icon name="arrow-1-left" height={10} />
          Back
        </Div>
        <Div className="filter-builder--set-name">
          <Input
            type="text"
            onChange={this.setSegmentName}
            label="Segment name"
            placeholder="Add segment name"
          />
        </Div>
        <Div className="filter-builder--set-type">
          <Div className="filter-builder--type-row">
            <Input
              type="radio"
              value="DYNAMIC"
              onChange={this.setSegmentType}
              checked={equals('DYNAMIC', currentSegment.type)}
              label={'Dynamic'}
            />
            <Div>
              <P>{LABELS['DYNAMIC_DESCRIPTION']}</P>
            </Div>
          </Div>
          <Div className="filter-builder--type-row">
            <Input
              type="radio"
              value="STATIC"
              onChange={this.setSegmentType}
              checked={equals('STATIC', currentSegment.type)}
              label={'Static'}
            />
            <Div>
              <P>{LABELS['STATIC_DESCRIPTION']}</P>
            </Div>
          </Div>
        </Div>
      </Div>
    )
  }
}

export default SetSegmentName
